import { useCallback, useEffect, useRef, useState } from 'react'

import Layout from '../../Layout';
import { Tabs, TabsProps } from 'antd';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './styles.scss'

// import './stylesv2.scss'
import Infomation from './components/Infomation';
import InfomationLeft from './components/InfomationLeft/InfomationLeft';
import useToast from '../../hook/useToast';
import useDebounce from '../../hook/useDebounce';
import { getInfoCustomer, ICustomerDetail_V4 } from '../../api/customer/customerApi';
import { getListTypePhone, ISelectOption } from '../../api/selectOptions/selectOptionsApi';
import { fommatSelectOption } from '../../until';
import { mixGetV2 } from '../../services/mixin';
import Overview from './components/Overview';
import useLoading from '../../hook/useLoading';
import { selectorSourceColumnWarehouse } from '../../store/slices/sourceColumnWarehouseSlice';
import { useSelector } from 'react-redux';
import VehicleInformation from './components/VehicleInformation';
import TabInvoiceHistory from './components/Tabs/TabInvoiceHistory';
import UpdateHistory from './components/Tabs/UpdateHistory';
import InteractionHistory from './components/Tabs/TabInteractionHistory';
import { selectLoadingCount } from '../../store/slices/loadingSlice';
// import Overview from '../CustomerInfoNewV2/components/Overview';

const CustomerInfoNewNotAPINhanV2 = () => {
  const sourceColumnWarehouse = useSelector(selectorSourceColumnWarehouse);
  const location = useLocation();
  const isEdit = location?.state?.isEdit

  const {
    firstPage,
    id, inforNodeEvent,
    restorePagination, restoreDataFilterList,

    brandId,
    dataFilter,
    unitIdDefault,
    type,
    brandName,
    idFirstPage,
    backState
  } = location?.state ?? {}

  const navigate = useNavigate()
  const pushToast = useToast();
  const pushLoading = useLoading()

  const isFetchingDetail = useRef(false);

  const [sLTypePhone, setSLTypePhone] = useState<ISelectOption[]>([]);

  const [activeTab, setActiveTab] = useState("1")

  const [infoCustomer, setInfoCustomer] = useState<ICustomerDetail_V4>()


  const gSLTypePhone = async () => {
    const result = await getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data));
    } else {
      pushToast(result?.message, "error");
    }
  };








  const gInfoCustomer = useDebounce(async () => {
    pushLoading(true)
    const result = await getInfoCustomer(Number(id))
    if (result?.status) {
      setInfoCustomer(result.data)
    } else {
      pushToast(result?.message, "error")
      navigate(-1)
    }
    pushLoading(false)
  }, 1000)



  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const resultFormSubmitPersonalInfor = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      gInfoCustomer()
    }
  }

  useEffect(() => {
    if (id && typeof (id) === "number") {
      if (!sLTypePhone.length)
        gSLTypePhone()

      setActiveTab("1")

      gInfoCustomer()

    } else {
      navigate(-1)
    }

  }, [navigate, id])

  return (
    <Layout>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: <Link to="/customer/list">Khách hàng</Link>, },
          { title: <Link to="/customer/list">Danh sách khách hàng</Link>, },
          { title: 'Thông tin khách hàng', },
        ]}
        title='Thông tin khách hàng'
        backLink={firstPage ?? '/customer/list'}
        idBackLink={idFirstPage}
        className="gutter-block-end"
        
        inforNodeEvent={inforNodeEvent}
        restorePagination={restorePagination}
        restoreDataFilterList={restoreDataFilterList}

        brandId={brandId}
        dataFilter={dataFilter}
        unitIdDefault={unitIdDefault}
        type={type}
        brandName={brandName}
        backState={backState}
      />
      <div
        // className="custom-page-css w-full flex flex-column gap-2 overflow-y-scroll"
        // style={{ height: 'calc(100% - 96px)' }}

        className={`${activeTab == '1' ? '' : 'pr-1'} custom-page-css w-full flex flex-column gap-2 `}
        style={{
          height: activeTab == '1' ? 'calc(100% - 96px)' : '100%',
          overflowY: activeTab == '1' ? 'hidden' : 'scroll',

        }}
      >

        <div
          className={activeTab !== "1" ? '' : 'hidden '}
        >
          <Infomation
            sLTypePhone={sLTypePhone}
            infoCustomer={infoCustomer}
          />
        </div>
        <div className="custom-page-css w-full h-full flex gap-2"

        >
          <div
            className={activeTab == '1' ? 'custom-page-css h-full w-1-4 shrink-0 transition overflow-y-scroll' : 'hidden '}
          >
            <InfomationLeft
              isEdit={isEdit}
              sLTypePhone={sLTypePhone}
              infoCustomer={infoCustomer}
              resultFormSubmitPersonalInfor={resultFormSubmitPersonalInfor}
            />
          </div>
          <div className={`custom-page-css w-full h-full  ${activeTab == '1' ? 'overflow-y-scroll pr-1' : ""}`}>
            <Tabs
              className='h-full custom-tab-child'
              activeKey={activeTab}
              items={[

                {
                  key: '1',
                  label: <span className='custom-page-css font-light text-lg'>Tổng quan</span>,
                  children:
                    <Overview
                      infoCustomer={infoCustomer}
                    />,
                },
                {
                  key: '2',
                  label: <span className='custom-page-css font-light text-lg'>Thông tin xe</span>,
                  children:
                    <VehicleInformation
                      infoCustomer={infoCustomer}
                    />,
                },
                {
                  key: '3',
                  label: <span className='custom-page-css font-light text-lg'>Lịch sử hóa đơn</span>,
                  children:
                    <TabInvoiceHistory
                      infoCustomer={infoCustomer}
                    />,
                },
                {
                  key: '4',
                  label: <span className='custom-page-css font-light text-lg'>Lịch sử tương tác</span>,
                  children:
                    <InteractionHistory
                      infoCustomer={infoCustomer}
                    />,
                },
                {
                  key: '5',
                  label: <span className='custom-page-css font-light text-lg'>Lịch sử cập nhật</span>,
                  children:
                    <UpdateHistory
                      infoCustomer={infoCustomer}
                    />,
                  style: {
                    height: '100%'
                  }
                },

              ]}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
    </Layout>

  );
};
export default CustomerInfoNewNotAPINhanV2
